"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const CompareSelectGroup_1 = __importDefault(require("./CompareSelectGroup"));
const Compare_1 = __importDefault(require("./Compare"));
const icons_1 = require("../../atoms/icons");
const typography_1 = require("../../shared/typography");
const utils_1 = require("../../molecules/utils");
exports.default = ({ onClickArrowBack, rightPhoto, leftPhoto, availableWeeks, selectsValues, onChangeLeftCompareSelect, onChangeRightCompareSelect, translation, leftMeasurement, rightMeasurement, unitOfWeight, unitsOfLength, fetchImageAsBase64 }) => {
    const imgContainerRef = (0, react_1.useRef)(null);
    const [height, setHeight] = (0, react_1.useState)(0);
    const [photoLeft, setPhotoLeft] = (0, react_1.useState)("");
    const [photoRight, setPhotoRight] = (0, react_1.useState)("");
    const fetchImage = (setState) => async (url) => {
        const base64 = await fetchImageAsBase64(url);
        setState(base64);
    };
    (0, react_1.useEffect)(() => {
        setPhotoLeft("");
        fetchImage(setPhotoLeft)(leftPhoto);
    }, [leftPhoto]);
    (0, react_1.useEffect)(() => {
        setPhotoRight("");
        fetchImage(setPhotoRight)(rightPhoto);
    }, [rightPhoto]);
    (0, react_1.useEffect)(() => {
        if (imgContainerRef.current) {
            setHeight(imgContainerRef.current.clientHeight);
        }
    }, [photoLeft, photoRight]);
    if (!photoLeft && !photoRight)
        return ((0, jsx_runtime_1.jsx)(LoadingWrapper, { children: (0, jsx_runtime_1.jsx)(utils_1.Loader, {}, void 0) }, void 0));
    return ((0, jsx_runtime_1.jsxs)(Container, { children: [(0, jsx_runtime_1.jsxs)("div", { "data-back": "true", children: [(0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", color: "grey", onClick: onClickArrowBack, icon: ["far", "arrow-left"], size: "lg" }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: translation.measurements.title }, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)("div", { ref: imgContainerRef, children: [photoLeft ? ((0, jsx_runtime_1.jsx)("img", { src: photoLeft, alt: "image one" }, void 0)) : ((0, jsx_runtime_1.jsx)(Placeholder, { height: height, children: (0, jsx_runtime_1.jsx)(utils_1.Loader, {}, void 0) }, void 0)), photoRight ? ((0, jsx_runtime_1.jsx)("img", { src: photoRight, alt: "image two" }, void 0)) : ((0, jsx_runtime_1.jsx)(Placeholder, { height: height, children: (0, jsx_runtime_1.jsx)(utils_1.Loader, {}, void 0) }, void 0))] }, void 0), (0, jsx_runtime_1.jsx)(CompareSelectGroup_1.default, { availableWeeks: availableWeeks, weekTranslation: translation.measurements.week, selectsValues: selectsValues, onChangeLeftCompareSelect: onChangeLeftCompareSelect, onChangeRightCompareSelect: onChangeRightCompareSelect }, void 0), (0, jsx_runtime_1.jsx)(Compare_1.default, { translations: translation.compare, leftMeasurement: leftMeasurement, rightMeasurement: rightMeasurement, unitOfWeight: unitOfWeight, unitsOfLength: unitsOfLength, isMobile: true }, void 0)] }, void 0));
};
const LoadingWrapper = styled_components_1.default.div `
  height: 80vh;
`;
const Placeholder = styled_components_1.default.div `
  align-items: center;
  display: flex;
  height: ${({ height }) => `${height}px`};
  justify-content: center;
  width: 100%;

  & > div {
    transform: translateY(-1.5rem);
  }
`;
const Container = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.silverLighten70};
  height: 100%;
  padding-top: ${({ theme }) => theme.spacings.m};
  [data-back="true"] {
    padding-left: ${({ theme }) => theme.spacings.m};
  }
  & > div:first-of-type {
    align-items: center;
    display: flex;
    justify-items: center;
    margin-bottom: ${({ theme }) => theme.spacings.m};
    padding-right: ${({ theme }) => theme.spacings.xl};
    width: 100%;

    div {
      justify-self: flex-start;
    }

    p {
      flex: 1;
      margin-bottom: 0;
      text-align: center;
    }
  }

  & > div:nth-of-type(2) {
    display: flex;
    align-items: flex-start;
    max-height: 70vh;

    img {
      height: auto;
      object-fit: contain;
      width: 50%;
    }
  }
`;
//# sourceMappingURL=CompareMobile.js.map